import React, { Component } from 'react'
import classNames from 'classnames'

import './SnackBar.css'

class SnackBar extends Component {

	state = {
		visible: false
	}

	componentDidMount() {
		setTimeout(this.show, 100)
	}

	componentDidUpdate(prevProps) {
		if (prevProps.message !== this.props.message) {
			this.show()
		}
	}

	show = () => {
		clearTimeout(this.timeout)
		this.setState({ visible: true })
		this.timeout = setTimeout(this.hide, 3000)
	}

	hide = () => {
		this.setState({ visible: false })
		setTimeout(this.props.onClose, 300)
	}

	render() {
		return (
			<div className={classNames('SnackBar', { visible: this.state.visible })}>
				<div>{this.props.message}</div>
			</div>
		)
	}
}

export default SnackBar



// WEBPACK FOOTER //
// ./src/components/SnackBar/SnackBar.js